import { combineReducers } from 'redux'
import portal from './portal'
import info from './info'

export default combineReducers({
  portal,
  info,
})



// WEBPACK FOOTER //
// ./src/reducers/index.js